import { render, staticRenderFns } from "./group-aggregates.vue?vue&type=template&id=391aeb51&scoped=true"
import script from "./group-aggregates.vue?vue&type=script&lang=js"
export * from "./group-aggregates.vue?vue&type=script&lang=js"
import style0 from "./group-aggregates.vue?vue&type=style&index=0&id=391aeb51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391aeb51",
  null
  
)

export default component.exports